module.exports = {
  title: 'Terms and Conditions',
  author: 'Enzo Manuel Mangano',
  date: '2024-12-07',
  slug: 'terms',
  tags: ['docs', 'terms-and-conditions'],
};
